import React from "react";

export const ContactMessage = () => {
  return (
    <div>
      <p>El mensaje fue enviado con éxito</p>
      <p>¡Gracias por comunicarte con nosotras!</p>
      <p>Te contactaremos a la brevedad</p>
    </div>
  );
};
